




































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import UpdateSecondaryWalletInterestSettingsRequest from '@/models/Accounts/DepositAccounts/Wallets/UpdateSecondaryWalletInterestSettingsRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'SecondaryInterestSettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    InterestRateType = InterestRateType;
    valid = true;
    dialog = false;
    updateSecondaryWalletRequest: UpdateSecondaryWalletInterestSettingsRequest = new UpdateSecondaryWalletInterestSettingsRequest(this.currentWalletInterestSettings);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.updateSecondaryWalletRequest = new UpdateSecondaryWalletInterestSettingsRequest(this.currentWalletInterestSettings);
            await RateSourceModule.getRateSources(1);
        }
    }

    get currentWalletInterestSettings() {
        return DepositAccountModule.currentDepositAccountWallet.walletSettings.depositInterestSettings;
    }

    get rateSourceOptions() {
        return RateSourceModule.rateSources;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    async save() {
        if (!this.valid) {
            return;
        }
        else {
            this.dialog = false;
            await DepositAccountModule.updateAccountSecondaryWalletInterestSettings(this.updateSecondaryWalletRequest);
        }
    }

}
